import React, { useEffect, useState } from "react";
import "./AddValidateur.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "../../../../../../../Utils/utils";

function AddIntervenant({ eu, ee, es, pt }) {
    const [modal, setModal] = useState(false);

    const { id } = useParams();

    const toggleModalAddIntervenant = () => {
        setModal(!modal);
    };

    if (modal) {
        document.body.classList.add("active-modal");
    } else {
        document.body.classList.remove("active-modal");
    }

    const [prenom, setPrenom] = useState("");
    const [nom, setNom] = useState("");
    const [eeOuSt, setEEOuSt] = useState("");
    const [idEntre, setIdEntre] = useState("");
    const [validAutocomplete, setValidAutocomplete] = useState([]);
    const [eeEntreprise, setEeEntreprise] = useState("");
    const [esEntreprise, setEsEntreprise] = useState("");

    const contactsReducer = useSelector((state) => state.contactsReducer);
    const entrepriseReducer = useSelector((state) => state.entrepriseReducer);

    const handleAddIntervenant = () => {
        let data = {};

        if (eeOuSt === "ee") {
            data = {
                prenom: prenom,
                nom: nom,
                entreprise: eeOuSt,
                id_entreprise: eeEntreprise,
            };
        } else {
            data = {
                prenom: prenom,
                nom: nom,
                entreprise: eeOuSt,
                id_entreprise: esEntreprise,
            };
        }

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/pt/intervenant/${id}`,
            data: data,
            withCredentials: true,
        })
            .then(() => {
                alert("Contact ajouté");
                window.location = window.location;
            })
            .catch((err) => {
                console.log(err);
                alert("Erreur dans l'ajout du contact");
            });
    };

    const onChangeHandler = () => {
        if (eeOuSt === "ee") {
            let matches = [];
            console.log("ee");
            matches = contactsReducer.filter((user) => {
                if (user.id_entreprise === eeEntreprise) {
                    const regex = new RegExp(`${prenom}`, "gi");
                    if (user.prenom.match(regex)) {
                        return user;
                    }
                }
            });
            setValidAutocomplete(matches);
        } else if (eeOuSt === "es") {
            let matches = [];
            matches = contactsReducer.filter((user) => {
                if (user.id_entreprise === esEntreprise) {
                    const regex = new RegExp(`^${prenom}`, "gi");
                    if (user.prenom.match(regex)) {
                        return user;
                    }
                }
            });
            setValidAutocomplete(matches);
        }
    };

    const handleChangePrenom = (e) => {
        setPrenom(e.target.value);
        onChangeHandler();
    };

    const handleSelectedValid = (contact) => {
        console.log(contact);
        document.getElementById("prenom").value = contact.prenom;
        document.getElementById("nom").value = contact.nom;
        setPrenom(contact.prenom);
        setNom(contact.nom);

        setValidAutocomplete([]);
    };

    useEffect(() => {
        if (!isEmpty(entrepriseReducer[0])) {
            entrepriseReducer.map((entreprise) => {
                if (entreprise.raison_sociale === ee.nom_EE_PT) {
                    setEeEntreprise(entreprise.id_hash);
                    console.log("trouvé ee");
                }
                if (entreprise.raison_sociale === es.nom_ST_PT) {
                    setEsEntreprise(entreprise.id_hash);
                    console.log("trouvé es");
                }
            });
        }
    }, [entrepriseReducer]);

    return (
        <div>
            <button onClick={toggleModalAddIntervenant} className="button_add_validateur" style={{ zIndex: 0 }}>
                <FontAwesomeIcon icon={faCirclePlus} />
                Ajouter un intervenant
            </button>

            {modal && (
                <div className="AddValidateur_overlay">
                    <div className="AddValidateur_wrapper">
                        <div className="AddValidateur_modal">
                            <div className="AddValidateur_header">
                                Nouvel intervenant
                                <button
                                    type="button"
                                    className="modal-close-button"
                                    onClick={toggleModalAddIntervenant}
                                >
                                    X
                                </button>
                            </div>

                            <div className="AddValidateur_content">
                                <div style={{ marginTop: "20px" }} className="d-flex">
                                    <p>Appartient à : </p>
                                    <div className="form-check form-check-inline" style={{ marginLeft: "20px" }}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="radioEES"
                                            id="inlineCheckbox1"
                                            value="ee"
                                            onChange={(e) => setEEOuSt(e.target.value)}
                                        />
                                        <label className="form-check-label" htmlFor="inlineCheckbox1">
                                            EE
                                        </label>
                                    </div>
                                    {es.nom_ST_PT !== undefined && (
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="radioEES"
                                                id="inlineCheckbox2"
                                                value="es"
                                                onChange={(e) => setEEOuSt(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="inlineCheckbox2">
                                                ES
                                            </label>
                                        </div>
                                    )}
                                </div>
                                <input
                                    className="AddValidateur_content_input"
                                    type="text"
                                    placeholder="Prénom"
                                    id="prenom"
                                    onChange={(e) => handleChangePrenom(e)}
                                    autoComplete="off"
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setValidAutocomplete([]);
                                        }, 100);
                                    }}
                                />
                                <div
                                    style={{
                                        position: "fixed",
                                        backgroundColor: "white",
                                        width: "25%",
                                        marginTop: "100px",
                                    }}
                                >
                                    {validAutocomplete &&
                                        validAutocomplete.map(
                                            (suggest, i) =>
                                                i < 12 && (
                                                    <div
                                                        key={i}
                                                        className="suggest"
                                                        style={{ width: "50%", marginLeft: "13%" }}
                                                        onClick={() => handleSelectedValid(suggest)}
                                                    >
                                                        {suggest.prenom} {suggest.nom}
                                                    </div>
                                                )
                                        )}
                                </div>
                                <input
                                    className="AddValidateur_content_input"
                                    type="text"
                                    placeholder="Nom"
                                    id="nom"
                                    onChange={(e) => setNom(e.target.value)}
                                />
                            </div>

                            <button
                                type="button"
                                className="modal_button_imprimer_validateur"
                                onClick={handleAddIntervenant}
                            >
                                Ajouter le nouvel intervenant
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AddIntervenant;
